<div *ngIf="showAlways || unread > 0" class="rkt-unread-chats-badge icon icon--with-badge">
  <hk-wc-icon name="key-hand"></hk-wc-icon>
  <ion-badge *ngIf="unread > 0" color="danger">{{ unread }}</ion-badge>
</div>
